// ---------------------------------------------------------------------------
// Cele patru direcții de lucru, într-o singură listă.
//
// Erau scrise doar în pagina Servicii. De când formularul de contact întreabă
// „despre ce e vorba?", aceleași chei trebuie să apară în două locuri — iar o
// direcție adăugată într-unul singur ar fi lăsat lista de la contact în urmă.
//
// Cheia e și ancora din URL (/services#contract), și prefixul cheilor de
// traducere (`services.contract.title`), și valoarea trimisă către funcția de
// mail. Ordinea e cea din pagina Servicii.
// ---------------------------------------------------------------------------
export const SERVICE_KEYS = ['contract', 'quality', 'archaeology', 'lowCurrent'];

// La contact mai există o opțiune care nu e un serviciu: cine nu se regăsește
// în cele patru trebuie să poată trimite mesajul, nu să aleagă ceva greșit.
export const CONTACT_SUBJECTS = [...SERVICE_KEYS, 'other'];

// Cât de departe e lucrarea. Ne spune dacă e o cerere pentru săptămâna asta
// sau o discuție pentru la anul — dinainte de primul telefon.
export const TIMELINES = ['asap', 'm1to3', 'm3to6', 'm6plus', 'unsure'];
